// REFDISC2 (docs/build-briefs/REFDISC2-split-refund-one-card.md; DEC-305,
// "Refund to one card"). Pure display helpers for the refund sheet's "Refund
// to" list on an equal split. No DOM, no arithmetic of its own: every figure
// is the server's (RefundCardDto), this only words it.

import type { RefundCardDto } from "./api.ts";
import { formatCents } from "./money.ts";

/** "Guest 1", with the card brand and last4 when a card was vaulted from the
 * payment: "Guest 1 · Visa 4242". */
export function refundCardLabel(card: RefundCardDto): string {
  return card.cardBrand !== null && card.cardLast4 !== null
    ? `${card.guestLabel} · ${card.cardBrand} ${card.cardLast4}`
    : card.guestLabel;
}

/** "Paid $7.72 · $7.72 left to refund". The paid figure excludes the tip,
 * which is never refundable, so what the card paid and what it can get back
 * read on the same footing. */
export function refundCardSublabel(card: RefundCardDto, selected: boolean): string {
  const paid = formatCents(card.capturedCents - card.tipCents);
  const left = formatCents(card.refundableRemainingCents);
  const text = `Paid ${paid} · ${left} left to refund`;
  return selected ? `Refunding to this card · ${text}` : text;
}
